import { useCallback } from 'react';

import { useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';
import { VisitEnterButton } from '~libs.desktop.shared.visit-enter';

import { useVisitDependenciesContext } from '../../../../dependencies';
import { appointmentsTranslationKeys } from '../../../../translations';

type ContinueVisitButtonProps = {
   readonly appointmentId: number;
   readonly visitId: number;
   readonly patientId: number;
   readonly disabled: boolean;
   readonly visitType?: visitPaths.VisitType;
};

export const ContinueVisitButton = (props: ContinueVisitButtonProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const { accountConfigurationVerificationEventInterceptor } = useVisitDependenciesContext();

   const pushToVisit = useCallback(() => {
      push(visitPaths.getVisitEntryPath(props.visitId, props.visitType), {});
   }, [push, props.visitId, props.visitType]);

   return (
      <VisitEnterButton
         appointmentId={props.appointmentId}
         patientId={props.patientId}
         label={appointmentsTranslationKeys.finish}
         accountConfigurationVerificationEventInterceptor={accountConfigurationVerificationEventInterceptor}
         onClick={pushToVisit}
         testId='continueVisit'
         disabled={props.disabled}
      />
   );
};
